import EmployeesIndicators from './EmployeesIndicators';

export default EmployeesIndicators;
